// extracted by mini-css-extract-plugin
export default {"Box":"slicer-panel-resizer-module__Box--eRLCO","Box_1":"slicer-panel-resizer-module__Box_1--U9NsJ","isDragging":"slicer-panel-resizer-module__isDragging--cRM_R"};